import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const CDN_URL = import.meta.env.VITE_CDN_URL || '';
const I18N_FOLDER = import.meta.env.VITE_I18N_FOLDER || 'i18n/scio30-beta';
const I18N_BASE_URL =
  import.meta.env.DEV || import.meta.env.VITE_I18N_LOCAL
    ? '/i18n'
    : CDN_URL
      ? `${CDN_URL}/${I18N_FOLDER}`
      : '/i18n';
const STORAGE_KEY = 'language';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: localStorage.getItem(STORAGE_KEY) || undefined,
    fallbackLng: 'en',
    supportedLngs: ['en', 'de', 'es', 'fr', 'it', 'ja', 'nl', 'pt', 'sv'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: `${I18N_BASE_URL}/{{lng}}.json`,
    },
    react: {
      useSuspense: false, // Avoid flash — show stale text until loaded
      bindI18nStore: 'added removed', // Re-render when HttpBackend loads a new language bundle
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
    },
  });

const SUPPORTED_LANGS = ['en', 'de', 'es', 'fr', 'it', 'ja', 'nl', 'pt', 'sv'];

// Preload all languages in background so switching is instant
i18n.on('initialized', () => {
  i18n.loadLanguages(SUPPORTED_LANGS);
});

export { STORAGE_KEY };
export default i18n;
